import React, {useEffect, useState} from "react";
import {Result} from "antd";
import {Layout, Skeleton, Spin} from "antd/lib";
import {useCid, useOrderId} from "./hooks/UseOrderId";
import PkBankCardMode from "./components/paymentType/pk/PkBankCardMode";
import PkWalletRequestMode from "./components/paymentType/pk/PkWalletRequestMode";
import PkPayProIdMode from "./components/paymentType/pk/PkPayProIdMode";
import PkKuickPayIdMode from "./components/paymentType/pk/PkKuickPayIdMode";
import PkKaroRedirectMode from "./components/paymentType/pk/PkKaroRedirectMode";
import PkSimpaisaMode from "./components/paymentType/pk/PkSimpaisaMode";
import PkPayFastRedirectMode from "./components/paymentType/pk/PkPayFastRedirectMode";

import IdNavigationMode from "./components/paymentType/id/IdNavigationMode";
import IdBankCardMode from "./components/paymentType/id/IdBankCardMode";
import IdWalletMode from "./components/paymentType/id/IdWalletMode";

import IdOvoMode from "./components/paymentType/id/IdOvoMode";
import IdQrCodeMode from "./components/paymentType/id/IdQrCodeMode";

import BdBankCardMode from "./components/paymentType/bd/BdBankCardMode";

import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";

import {useGetCheckoutApi} from "./api";
import PkQisstEasypaisaMode from "./components/paymentType/pk/PkQisstEasypaisaMode";
import PkPaymobMode from "./components/paymentType/pk/PkPaymobMode";
import PkPayItIdMode from "./components/paymentType/pk/PkPayItIdMode";
import {ProductNameEnum} from "./types/ProductNameEnum";
import PkQisstEasypaisaModeV4 from "./components/paymentType/pk/PkQisstEasypaisaModeV4";
// import PkJazzcashMode from "./components/paymentType/pk/PkJazzcashMode";
import PkJazzcashTestMode from "./components/paymentType/pk/PkJazzcashTestMode";
import PkDynamicWalletRequest from "./components/paymentType/pk/PkDynamicWalletRequestMode";
import PkDynamicWalletRequestV2 from "./components/paymentType/pk/PkDynamicWalletRequestV2Mode";
import PkDynamicWalletRequestV3 from "./components/paymentType/pk/PkDynamicWalletRequestV3Mode";
import PkDynamicWalletRequestV4 from "./components/paymentType/pk/PkDynamicWalletRequestV4Mode";
import PkDynamicWalletRequestV5 from "./components/paymentType/pk/PkDynamicWalletRequestV5Mode";
import PkDynamicWalletRequestV6 from "./components/paymentType/pk/PkDynamicWalletRequestV6Mode";
import PkDynamicWalletRequestV7 from "./components/paymentType/pk/PkDynamicWalletRequestV7Mode";
import PkDynamicWalletRequestFirstpayV1 from "./components/paymentType/pk/PkDynamicWalletRequestFirstpayV1Mode";
import PkDynamicWalletRequestFirstpayV2 from "./components/paymentType/pk/PkDynamicWalletRequestFirstpayV2Mode";
import PkDynamicWalletRequestFirstpayV3 from "./components/paymentType/pk/PkDynamicWalletRequestFirstpayV3Mode";
import PkDynamicWalletRequestFirstpayV4 from "./components/paymentType/pk/PkDynamicWalletRequestFirstpayV4Mode";
import PkDynamicWalletRequestFirstpayV5 from "./components/paymentType/pk/PkDynamicWalletRequestFirstpayV5Mode";
import PkDynamicWalletRequestMobileV1 from "./components/paymentType/pk/PkDynamicWalletRequestMobileV1Mode";
import PkDynamicWalletRequestMobileV2 from "./components/paymentType/pk/PkDynamicWalletRequestMobileV2Mode";
import PkDynamicWalletRequestMobileV3 from "./components/paymentType/pk/PkDynamicWalletRequestMobileV3Mode";
import PkRouteSetting from "./components/paymentType/pk/PkRouteSettingMode";
import PkRouteSettingFirstpay from "./components/paymentType/pk/PkRouteSettingFirstpayMode";
import PkAjarMode from "./components/paymentType/pk/PkAjarMode";
import PkBankToBankMode from "./components/paymentType/pk/PkBankToBankMode";
import PkSadapayMode  from "./components/paymentType/pk/PkSadapayMode";
import PkBillpayMode from "./components/paymentType/pk/PkBillpayMode";
import BdWalletMode from "./components/paymentType/bd/BdWalletMode";

export interface PaymentType {
  getCheckoutInfoData: any;
}

const paymentTypes = {
  // pk - QQ
  "03": PkBankCardMode,
  "04": PkWalletRequestMode,
  "05": PkPayProIdMode,
  "06": PkKuickPayIdMode,
  "08": PkKaroRedirectMode,
  "09": PkSimpaisaMode,
  "10": PkQisstEasypaisaMode,
  "11": PkPaymobMode,
  "12": PkPayItIdMode,
  "13": PkQisstEasypaisaModeV4,

  // pk - Karo
  "07": PkPayFastRedirectMode,
  // "15": PkJazzcashMode,
  "15": PkJazzcashTestMode,
  "16": PkDynamicWalletRequest,
  "17": PkAjarMode,
  "18": PkDynamicWalletRequestV2,
  "19": PkDynamicWalletRequestV3,
  "20": PkBankToBankMode,
  "21": PkDynamicWalletRequestV4, 
  "22": PkDynamicWalletRequestV5,
  "23": PkDynamicWalletRequestV6,
  "24": PkDynamicWalletRequestV7,
  "25": PkSadapayMode,
  "26": PkDynamicWalletRequestFirstpayV1,
  "27": PkDynamicWalletRequestFirstpayV2,
  "28": PkDynamicWalletRequestFirstpayV3,
  "29": PkDynamicWalletRequestFirstpayV4,
  "30": PkDynamicWalletRequestFirstpayV5,
  "31": PkDynamicWalletRequestMobileV1,
  "32": PkDynamicWalletRequestMobileV2,
  "33": PkDynamicWalletRequestMobileV3,
  "34": PkRouteSetting,
  "35": PkBillpayMode,
  "36": PkRouteSettingFirstpay,

  // id - QQ
  "1000": IdNavigationMode,
  "1001": IdBankCardMode,
  "1002": IdWalletMode,
  "1003": IdOvoMode,
  "1004": IdQrCodeMode,

  // BD
    "2001": BdBankCardMode,
    "2002": BdWalletMode
};

const heightOfHeaderAndFooter = 128;

const appName = process.env.REACT_APP_NAME as ProductNameEnum;

function App() {

  const id = useOrderId();
  const cid = useCid();

  const {
    data: getCheckoutInfoData,
    loading,
        error: getCheckoutInfoError
    } = useGetCheckoutApi(id, cid);

  const PaymentComponent =
    paymentTypes[
      getCheckoutInfoData?.checkoutType as keyof typeof paymentTypes
    ];

  useEffect(() => {
    console.log("[GET] checkout.data", getCheckoutInfoData);
    console.log("[GET] checkout.getCheckoutInfoError", getCheckoutInfoError);
  }, [getCheckoutInfoData, getCheckoutInfoError]);


    const [minHeight, setMinHeight] = useState(window.innerHeight - heightOfHeaderAndFooter);
    const backgroundColor = appName === ProductNameEnum.KaroPay ? "white" : undefined;

  const handleResize = (e: UIEvent) => {
    setMinHeight(window.innerHeight - heightOfHeaderAndFooter);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

    if (window.location.href.endsWith('/jazzcash_return.html')) {
    return (
      <Layout>
                <Header/>
                    <div style={{minHeight, backgroundColor}}>
                        <Result status="info" title="Please check the payment status in the merchant app."/>
        </div>
                <Footer/>
      </Layout>
    );
  } else {
    return (
      <Spin tip="Loading" size="large" spinning={loading}>
        <Layout>
                    <Header/>
                    <div style={{minHeight, backgroundColor}}>
                        {loading && <Skeleton/>}
            {!loading && getCheckoutInfoError && (
              <Result
                status="404"
                title="404"
                subTitle="Sorry, the order you visited does not exist."
              />
            )}
            {!loading &&
              !getCheckoutInfoError &&
              getCheckoutInfoData?.checkoutType && (
                                <PaymentComponent getCheckoutInfoData={getCheckoutInfoData}/>
              )}
          </div>
          {/*<Footer/>*/}
        </Layout>
      </Spin>
    );
  }
}

export default App;
